import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const TestimonialPaginationSection: StyleRule = ({
    theme,
    inLowerBound,
    inUpperBound,
    index,
}) => ({
    '& .swiper-pagination-custom': {
        textAlign: 'left',
        width: '50%',
    },

    '& .ellipsisFirst': {
        display: !inLowerBound ? 'inline-block' : 'none',
        position: 'relative',
        margin: pxArrayToRem([0, 14]),
        fontSize: pxToRem(22),
        top: pxToRem(1),
    },
    '& .ellipsisLast': {
        display: !inUpperBound ? 'inline-block' : 'none',
        position: 'relative',
        margin: pxArrayToRem([0, 14]),
        fontSize: pxToRem(22),
        top: pxToRem(1),
    },
    '& .topBottomPage': {
        display: 'inline-block',
    },
    '& .lowerBound': {
        display: inLowerBound ? 'inline-block' : 'none',
    },
    '& .upperBound': {
        display: inUpperBound ? 'inline-block' : 'none',
    },
    '& > .lowerBound.upperBound': {
        display: inUpperBound || inLowerBound ? 'inline-block' : 'none',
    },
    '& .regular': {
        display: 'none',
    },
    '& .swiper-pagination-bullet': {
        fontSize: theme.siteVariables.fontSizes.caption02,
        cursor: 'pointer',
        minWidth: pxToRem(50),
        marginRight: pxToRem(20),
        paddingTop: pxToRem(15),
        height: pxToRem(50),
        borderRadius: 0,
        background: 'transparent',
        opacity: 0.8,
        '&:hover': {
            opacity: 1,
            borderBottom: `2px solid ${theme.siteVariables.colors.charcoal['250']}`,
        },

        '&.swiper-pagination-bullet-active': {
            cursor: 'default',
            opacity: 1,
            borderBottom: `2px solid ${theme.siteVariables.colors.charcoal['250']}`,
            '&:hover': {
                background: 'transparent',
            },
        },

        [`&:nth-child(n + ${index - 1}):nth-child(-n + ${index + 1})`]: {
            display: 'inline-block',
        },
        [`&:last-child`]: {
            display: `inline-block`,
        },
        [`&:first-child`]: {
            display: `inline-block`,
        },
    },

    '& .isSimple': {
        display: 'inline-block',
    },
});
